import { z } from "zod/v4";

export const UserAlertsDtoSchema = z.object({
  showPersonalizationsDialog: z.boolean().default(false).optional(),
  showPersonalizationMigrateBanner: z.boolean().default(false).optional(),
  showAnalyticsReleaseDialog: z.boolean().default(false).optional(),
});

export type UserAlertsDto = z.infer<typeof UserAlertsDtoSchema>;

export const UserAlertsInitial: UserAlertsDto = {
  showPersonalizationMigrateBanner: false,
  showPersonalizationsDialog: false,
  showAnalyticsReleaseDialog: false,
};
export const UserRolesList = ["intelligems", "admin", "member"] as const;
export type UserRoles = (typeof UserRolesList)[number];

export const UserDtoSchema = z.object({
  id: z.uuid(),
  firstName: z.string().nullish(),
  lastName: z.string().nullish(),
  email: z.email(),
  organizationId: z.uuid(),
  isBlocked: z.boolean(),
  showInfoPopup: z.boolean(),
  userAlerts: UserAlertsDtoSchema.partial().nullish(),
  showWelcome: z.boolean().optional().default(true),
  preferredName: z.string().nullish(),
  preferredEmail: z.string().nullish(),
  installer: z.boolean().default(false),
  companyRole: z.string().nullish(),
  previousExperience: z.string().nullish(),
});

export type UserDto = z.infer<typeof UserDtoSchema>;

export const CreateUserDtoSchema = z.object({
  email: z.string(),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  preferredName: z.string().nullish(),
  preferredEmail: z.string().nullish(),
  installer: z.boolean().default(false),
  companyRole: z.string().nullish(),
  previousExperience: z.string().nullish(),
  password: z.string().optional(),
  showWelcome: z.boolean().optional().default(true),
  showInfoPopup: z.boolean().optional().default(true),
  userAlerts: UserAlertsDtoSchema.optional(),
  organizationId: z.uuid(),
});
export type CreateUserDto = z.infer<typeof CreateUserDtoSchema>;

export const PatchUserDtoSchema = z.object({
  email: z.string().optional(),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  password: z.string().optional(),
  showWelcome: z.boolean().optional(),
  showInfoPopup: z.boolean().optional(),
  userAlerts: UserAlertsDtoSchema.partial().optional(),
  organizationId: z.uuid(),
  isBlocked: z.boolean().optional(),
  id: z.string().uuid(),
  preferredName: z.string().nullish(),
  preferredEmail: z.string().nullish(),
  installer: z.boolean().default(false).optional(),
  companyRole: z.string().nullish(),
  previousExperience: z.string().nullish(),
});

export type PatchUserDto = z.infer<typeof PatchUserDtoSchema>;
